import { CloudOff, RotateCw } from "lucide-react";

/**
 * "Couldn't load …" in the kit (#1221 slice 2): the card the coach's player
 * page draws for a list or a read that failed, in place of an empty claim
 * (D53 ruling 2, #271). The anatomy is the round-11 boards' failed-to-load
 * state: a tile with the alert glyph, a 14px 600 title, the line that says
 * nothing was lost, and a 44px Try again. `LoadFailureNote.jsx` is the
 * shipped version of the same thing and stays for the pages not redrawn.
 *
 * `testId` goes on the card; Try again is `<testId>-retry`.
 */
export default function LoadFailedCard({ title, onRetry, testId }) {
  return (
    <div
      data-testid={testId}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        padding: "20px 16px",
        background: "var(--nw-surface)",
        border: "1px solid var(--nw-line)",
        borderRadius: "var(--nw-radius-card)",
        textAlign: "center",
        minWidth: 0,
      }}
    >
      <div style={{ width: 44, height: 44, borderRadius: 14, background: "var(--nw-line-faint)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CloudOff size={20} color="var(--nw-alert)" strokeWidth={2} aria-hidden="true" />
      </div>
      <div style={{ fontWeight: 600, fontSize: 14, color: "var(--nw-ink)", overflowWrap: "anywhere" }}>{title}</div>
      <div style={{ fontSize: 12, lineHeight: 1.5, color: "var(--nw-ink-muted)" }}>Nothing has been lost — we just couldn't reach the server.</div>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          data-testid={testId ? `${testId}-retry` : undefined}
          style={{
            marginTop: 6,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            minHeight: 44,
            minWidth: 44,
            padding: "0 14px",
            background: "var(--nw-surface)",
            border: "1px solid var(--nw-line-strong)",
            borderRadius: "var(--nw-radius-control)",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--nw-navy)",
            cursor: "pointer",
          }}
        >
          <RotateCw size={14} strokeWidth={2} aria-hidden="true" />
          Try again
        </button>
      )}
    </div>
  );
}
